const NBSP = String.fromCharCode(0x00a0);

export const CURRENCY_CONFIGS = {
  EUR: {
    code: 'EUR',
    locale: 'it-IT',
    symbol: '€',
    position: 'prefix',
    thousand: '.',
    decimal: ',',
    scale: 2,
  },
  EUR_EN: {
    code: 'EUR',
    locale: 'en-US',
    symbol: '€',
    position: 'prefix',
    thousand: ',',
    decimal: '.',
    scale: 2,
  },
  USD: {
    code: 'USD',
    locale: 'en-US',
    symbol: '$',
    position: 'prefix',
    thousand: ',',
    decimal: '.',
    scale: 2,
  },
  GBP: {
    code: 'GBP',
    locale: 'en-GB',
    symbol: '£',
    position: 'prefix',
    thousand: ',',
    decimal: '.',
    scale: 2,
  },
};

export const LANG_CURRENCY_MAP = {
  it: 'EUR',
  en: 'EUR_EN',
};

export function formatCurrency(value, config = CURRENCY_CONFIGS.EUR) {
  if (value === null || value === undefined) return '';
  const num = typeof value === 'string' ? parseFloat(value) : Number(value);
  if (isNaN(num)) return '';
  const formatted = num.toLocaleString(config.locale, {
    minimumFractionDigits: config.scale,
    maximumFractionDigits: config.scale,
  });
  return config.position === 'suffix'
    ? `${formatted}${config.symbol}`
    : `${config.symbol}${formatted}`;
}

export function formatNumber(value, config = CURRENCY_CONFIGS.EUR) {
  if (value === null || value === undefined) return '';
  const num = typeof value === 'string' ? parseFloat(value) : Number(value);
  if (isNaN(num)) return '';
  return num.toLocaleString(config.locale, {
    minimumFractionDigits: config.scale,
    maximumFractionDigits: config.scale,
  });
}

export function formatPercent(value, config = CURRENCY_CONFIGS.EUR, maxDecimal = 2) {
  if (value === null || value === undefined) return '';
  const num = typeof value === 'string' ? parseFloat(value) : Number(value);
  if (isNaN(num)) return '';
  return `${num.toLocaleString(config.locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxDecimal,
  })}%`;
}
